/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';

  /**
   * Вид для блока быстрой доставки в правом блоке корзины
   */
  app.CartFastDeliveryView = app.View.extend({

    events: {
      'click .js-expand': 'expandBlock',
      'click .js-show-items-popup': 'showPopup',
    },
    additionalOptions: [],
    run: function () {
      this.listenTo(this.settlement, 'change', this.updateFastDelivery);
      this.sumTemplate = app.helpers.TemplateHelper.getTemplate('#fast-delivery-sum-template');
      this.expandableBlock = this.$('.js-expandable-block');
    },

    /**
     * Показать или скрыть блок быстрой доставки, а зависимости от fast_delivery_sum
     */
    updateFastDelivery: function () {
      var fastDeliveryBalance = this.cart.cartInfo.fast_delivery_sum;
      this.$el.toggleClass('not_display', !fastDeliveryBalance);
      if (fastDeliveryBalance) {
        this.renderFastDeliverySum(fastDeliveryBalance);
      }
    },

    /**
     * Разворачивание и сворачивание блока быстрой доставки
     */
    expandBlock: function () {
      var row = this.$('.js-arrow');
      row.toggleClass('arrow_down').toggleClass('arrow_up');
      this.expandableBlock.toggleClass('expanded');
    },

    /**
     * Рендер суммы быстрой доставки
      * @param sum
     */
    renderFastDeliverySum: function (sum) {
      this.$('.js-fast-delivery-sum').html(this.sumTemplate({
        sum: app.helpers.NumberHelper.fractionPrice(sum),
        currency: app.currentCurrency.sign,
      }));
    },

    /**
     * Показать попап с товарами для быстрой доставки
     */
    showPopup: function () {
      if (!this.childViews.itemsPopup) {
        this.initItemsPopup();
      }
      this.childViews.itemsPopup.fetchAndShow();
    },

    /**
     * Инициализация попапа заказа товаров с удаленного склада
     */
    initItemsPopup: function () {
      // Инициализируем отдельную коллекцию корзины с дополнительными параметрами
      var fastDeliveryItems = new app.Cart(null, {settlement: this.settlement});
      fastDeliveryItems.queryParams.is_fast_delivery = 1;
      fastDeliveryItems.state.pageSize = 100;

      this.childViews.itemsPopup = new app.ItemsPopupView({
        el: '.js-items-popup',
        collection: fastDeliveryItems
      });
    },
  });

})(jQuery);

}.call(window));